<template>
  <v-snackbar v-model="showSnackbar" :right="true" :timeout="2500" :top="true" :vertical="false">
    {{snackbarText}}
    <v-btn :color="snackbarColor" flat @click="showSnackbar = false">Close</v-btn>
  </v-snackbar>
</template>

<script>
export default {
  data() {
    return {
      showSnackbar: false,
      snackbarColor: "blue",
      snackbarText: ""
    };
  },
  methods: {
    display(options) {
      //console.log(options);

      this.snackbarText = options.text;
      this.snackbarColor = options.color;
      this.showSnackbar = true;
    }
  }
};
</script>

<style>
</style>
